/**
 * Screen-specific constants for the Schedule create/edit form.
 * Shared package-level constants live in `packages/schedules/constants`.
 */

// Maximum amount of triggers (event types) a schedule can hold.
export const MAX_TRIGGERS = 20;

export const SCHEDULE_CREATE_STEPS = {
  CONFIGURATION: 0,
  SUPERVISORS: 1,
  USERS: 2,
  TASKS: 3,
} as const;

export const SCHEDULE_CREATE_LAST_STEP = SCHEDULE_CREATE_STEPS.TASKS;

// Default schedule duration (in minutes) used as the form initial value.
export const DEFAULT_DURATION = 60;

// Minimum duration (in minutes) allowed by the duration field validator.
export const MIN_DURATION = 15;

// Name field length boundaries.
export const MIN_NAME_LENGTH = 5;
export const MAX_NAME_LENGTH = 180;

// When the schedule has no end date we push it far into the future so the
// backend treats it as "runs forever".
export const FAR_FUTURE_YEARS = 50;

interface ReminderOption {
  value: number;
  // IntlMessages id used to render the option label.
  labelId: string;
  // Optional values passed to the translation (e.g. `{ amount: 5 }`).
  values?: Record<string, number>;
}

// Reminder dropdown options. `value` is the amount of minutes before the start.
export const REMINDER_OPTIONS: ReminderOption[] = [
  { value: 0, labelId: 'schedule.reminder.none' },
  { value: 5, labelId: 'schedule.reminder.minutes', values: { amount: 5 } },
  { value: 15, labelId: 'schedule.reminder.minutes', values: { amount: 15 } },
  { value: 30, labelId: 'schedule.reminder.minutes', values: { amount: 30 } },
  { value: 60, labelId: 'schedule.reminder.hours', values: { amount: 1 } },
  { value: 120, labelId: 'schedule.reminder.hours', values: { amount: 2 } },
];
